<template>
  <div>
    <div class="w-full">
      <vx-card id="sitesCard" title="Sites" v-show="!isSiteListHidden">
        <vs-table stripe ref="sitesTable" class="vs-con-loading__container" single @selected="handleSelectedSite" pagination max-items="10" search :data="sites"> <!--  v-scroll-to="'#siteInfoCard'" -->
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <!-- ADD NEW -->
            <div v-show="canAddSites">
              <div class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewSite">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary">Add New</span>
              </div>
            </div>
          </div>
          <template slot="thead">
            <vs-th sort-key="companyName">Company Name</vs-th>
            <vs-th sort-key="firstName">Contact Person</vs-th>
            <vs-th sort-key="mobile">Contact Number</vs-th>
            <vs-th sort-key="email">Contact Email</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedBy">Modified By</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="sites" :key="indextr" v-for="(sites, indextr) in data">

              <vs-td :data="data[indextr].companyName">
                {{ sites.companyName }}
              </vs-td>

              <vs-td :data="data[indextr].firstName">
                {{ sites.firstName + " " + sites.lastName }}
              </vs-td>

              <vs-td :data="data[indextr].mobile">
                {{ sites.mobile }}
              </vs-td>

              <vs-td :data="data[indextr].email">
                {{ sites.email }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedOn">
                {{ sites.modifiedOn.replace("T", " ").split('.')[0] }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedBy">
                {{ sites.modifiedBy }}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div>
      <!-- <div v-show="!isInfoHidden"> -->
      <vx-card id="siteInfoCard" title="Site Info" v-show="!isInfoHidden">
        <vs-divider class="mb-6">Company Details</vs-divider>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Name</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required'" name="Company Name" icon-pack="feather" icon="icon-briefcase" v-model="formData.companyName" />
            <span class="text-danger text-sm" v-show="errors.has('Company Name')">{{ errors.first('Company Name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Type</label>
            <v-select ref="typeDropdown" class="w-full" placeholder="Search / Select a Company Type" :options="typeList" v-model="typeDropdown"></v-select>
          </div>
        </div>
        <div class="vx-row pb-3" v-show="typeDropdown && typeDropdown.value == 1">
          <div class="vx-col w-full mb-2">
            <label>Select a School To Inherit Content From</label>
            <v-select ref="inheritDropdown" class="w-full" placeholder="Search / Select a School" :options="inheritList" v-model="inheritDropdown"></v-select>
          </div>
        </div>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>VAT Number</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'numeric'" name="VAT number" icon-pack="feather" icon="icon-hash" v-model="formData.vatNumber" />
            <span class="text-danger text-sm" v-show="errors.has('VAT number')">{{ errors.first('VAT number') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Registration Number</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="{regex: '^[0-9/]+$' }" name="Company Registration" icon-pack="feather" icon="icon-hash" v-model="formData.registration" />
            <span class="text-danger text-sm" v-show="errors.has('Company Registration')">{{ errors.first('Company Registration') }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Number of Employees</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-1/2" v-validate="'numeric'" name="Number of Employees" icon-pack="feather" icon="icon-hash" v-model="formData.employeeNumber" />
            <span class="text-danger text-sm" v-show="errors.has('Number of Employees')">{{ errors.first('Number of Employees') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Address</label>
            <vs-textarea class="w-full" v-model="formData.address" />
          </div>
        </div>
        <div class="vx-row" v-if="typeDropdown && typeDropdown.value == 1">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-checkbox v-if="$siteTypeId() == 1" v-model="formData.virtualClassroom">Enable Class Rooms</vs-checkbox>
          </div>
        </div>
        <div class="vx-row" v-if="$siteTypeId() != 1">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-checkbox v-model="formData.oneTaskAttempt">One Task Attempt</vs-checkbox>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-checkbox v-model="formData.emailNotificationsEnabled">Receive Email Notifications</vs-checkbox>
          </div>
        </div>
        <div v-if="typeDropdown && typeDropdown.value != 1" class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-checkbox v-model="formData.isMentoringAvailable">Mentoring Available</vs-checkbox>
          </div>
        </div>
        <vs-divider v-if="formData.webIntegrationUsername" class="mb-6 pt-0">Website Integration User Info</vs-divider>
        <div v-if="formData.webIntegrationUsername" class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Username</label>
            <vs-input autocomplete="off" icon-no-border readOnly=true onClick="this.select();" class="w-full" icon-pack="feather" icon="icon-user" v-model="formData.webIntegrationUsername" />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Password</label>
            <vs-input autocomplete="off" icon-no-border readOnly=true onClick="this.select();" class="w-full" icon-pack="feather" icon="icon-lock" v-model="formData.webIntegrationPassword" />
          </div>
        </div>
        <vs-divider class="mb-6 pt-0">Contact Person / Administrator</vs-divider>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>First Name</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="First Name" icon-pack="feather" icon="icon-user" v-model="formData.firstName" />
            <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Last Name</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="Last Name" icon-pack="feather" icon="icon-user" v-model="formData.lastName" />
            <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
          </div>
        </div>
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Work Phone</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'numeric'" name="Work Phone" icon-pack="feather" icon="icon-phone" v-model="formData.work" />
            <span class="text-danger text-sm" v-show="errors.has('Work Phone')">{{ errors.first('Work Phone') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Mobile</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|numeric'" name="Mobile" icon-pack="feather" icon="icon-smartphone" v-model="formData.mobile" />
            <span class="text-danger text-sm" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>
          </div>
        </div>
        <div class="vx-row pb-3" v-show="!isAdminInfoHidden">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Email</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" type="email" v-validate="'required|email'" name="email" class="w-full" icon-pack="feather" icon="icon-at-sign" v-model="formData.email" />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Password</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" type="password" v-validate="'min:8|max:100'" name="password" ref="password" class="w-full" icon-pack="feather" icon="icon-lock" v-model="formData.password" />
            <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
        </div>
        <div class="vx-row pb-3" v-show="!isAdminInfoHidden">
          <div class="vx-col sm:w-1/2 w-full mb-2" v-show="formData.password">
            <label>Confirm Password</label>
            <vs-input autocomplete="off" icon-no-border onClick="this.select();" type="password" v-validate="'min:8|max:100|confirmed:password'" name="confirm_password" data-vv-as="password" class="w-full" icon-pack="feather" icon="icon-lock" v-model="formData.passwordConfirm" />
            <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>
          </div>
        </div>
        <vs-divider class="mb-6 pt-0">Home Page Logo</vs-divider>
        <div class="vx-col xl:w-1/6 mx-auto pt-2 self-center">
          <img sizes="100px" v-bind:src="formData.homePageImageUrl" v-show="formData.homePageImageUrl" @click="showUploadHomePageImage" width="100%" class="cursor-pointer">
          <div class="flex flex-wrap vs-con-loading__container items-center justify-center pb-4">
            <v-uploader @done="successUploadHomePageImage" v-show="!formData.homePageImageUrl" ref="homePageImageUpload" file-type-exts="jpeg,jpg,gif,png" button-text="Upload Image" language="en" file-size-limit="100MB" :preview="false"></v-uploader>
          </div>
        </div>
        <vs-divider class="mb-6 pt-0">Logo / Icon</vs-divider>
        <div class="vx-col xl:w-1/6 mx-auto pt-2 self-center">
          <img sizes="100px" v-bind:src="formData.logoUrl" v-show="formData.logoUrl" @click="showUpload" width="100%" class="cursor-pointer">
          <div class="flex flex-wrap vs-con-loading__container items-center justify-center pb-4">
            <v-uploader @done="successUpload" v-show="!formData.logoUrl" ref="fileUpload" file-type-exts="jpeg,jpg,gif,png" button-text="Upload Image" language="en" file-size-limit="100MB" :preview="false"></v-uploader>
          </div>
        </div>
        <div class="h-full">
          <vs-divider class="mb-6 pt-0">Theme</vs-divider>

          <!-- THEME COLORS -->
          <div>
            <h5>Primary Color</h5>
            <ul class="clearfix">
              <li @click="setSchoolPrimaryColor(color)" v-model="themeColor" v-for="color in themeColors" class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left" :style="{backgroundColor: color}" :class="{'shadow-outline': color == formData.schoolPrimaryColor}" :key="color"></li>
              <li @click="setSchoolPrimaryColor(schoolCustomPrimaryColor)" class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left" :style="{backgroundColor: schoolCustomPrimaryColor}" :class="{'shadow-outline': schoolCustomPrimaryColor == formData.schoolPrimaryColor}"></li>
              <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2" v-model="schoolCustomPrimaryColor" type="color" /></li>
            </ul>
          </div>
          <div class="mt-2">
            <h5>Secondary Color</h5>
            <ul class="clearfix">
              <li @click="setSchoolSecondaryColor(color)" v-for="color in themeColors" class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left" :style="{backgroundColor: color}" :class="{'shadow-outline': color == formData.schoolSecondaryColor}" :key="color"></li>
              <li @click="setSchoolSecondaryColor(schoolCustomSecondaryColor)" class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left" :style="{backgroundColor: schoolCustomSecondaryColor}" :class="{'shadow-outline': schoolCustomSecondaryColor == formData.schoolSecondaryColor}"></li>
              <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2" v-model="schoolCustomSecondaryColor" type="color" /></li>
            </ul>
          </div>
          <div class="mt-2">
            <h5>Tertiary Color</h5>
            <ul class="clearfix">
              <li @click="setSchoolTertiaryColor(color)" v-for="color in themeColors" class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left" :style="{backgroundColor: color}" :class="{'shadow-outline': color == formData.schoolTertiaryColor}" :key="color"></li>
              <li @click="setSchoolTertiaryColor(schoolCustomTertiaryColor)" class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left" :style="{backgroundColor: schoolCustomTertiaryColor}" :class="{'shadow-outline': schoolCustomTertiaryColor == formData.schoolTertiaryColor}"></li>
              <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2" v-model="schoolCustomTertiaryColor" type="color" /></li>
            </ul>
          </div>
          <div class="mt-2">
            <h5>Font Color</h5>
            <ul class="clearfix">
              <li @click="setSchoolFontColor(color)" v-for="color in themeColors" class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left" :style="{backgroundColor: color}" :class="{'shadow-outline': color == formData.schoolFontColor}" :key="color"></li>
              <li @click="setSchoolFontColor(schoolCustomFontColor)" class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left" :style="{backgroundColor: schoolCustomFontColor}" :class="{'shadow-outline': schoolCustomFontColor == formData.schoolFontColor}"></li>
              <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2" v-model="schoolCustomFontColor" type="color" /></li>
            </ul>
          </div>
          <div class="mt-3">
            <vs-button type="border" color="success" @click="openPreviewPopup">Preview</vs-button>
          </div>
        </div>
        <vs-divider class="mb-6 pt-0"></vs-divider>
        <div class="vx-row">
          <div v-show="formData.id" class="vx-col">
            <vs-button v-show="isBulkAddHidden" color="success" type="border" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="bulkStudentAdd" ref="bulkAddButton">Bulk Student Add</vs-button>
            <div class="flex flex-wrap items-center justify-center">
              <div class="vs-con-loading__container">
                <v-uploader v-show="!isBulkAddHidden && !bulkCsvFileUrl" @done="csvSuccessUpload" ref="bulkUpload" file-type-exts="csv" button-text="Upload .csv" language="en" file-size-limit="100MB" :preview="false"></v-uploader>
              </div>
              <vs-button v-show="bulkCsvFileUrl" ref="confirmBulkButton" color="success" size="small" class="mb-4 mr-3" @click="confirmBulkStudentAdd">Add Students</vs-button>
              <vs-button v-show="!isBulkAddHidden" :disabled="!canCancel" type="border" size="small" class="mb-4 ml-3" @click="downloadTemplate">Get Template</vs-button>
              <vs-button v-show="!isBulkAddHidden" :disabled="!canCancel" color="warning" size="small" class="mb-4 ml-3" @click="cancelBulkAdd">Cancel</vs-button>
            </div>
          </div>
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveEditSite" ref="saveEditButton">Save</vs-button>
            <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#siteInfoCard'" @click="cancelAdd">Cancel</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
    <vs-popup id="bulkNotAddedPopup" title="Information of Students NOT Added" :active.sync="bulkNotAddedPopupActive">
      <div v-if="bulkAddResponse && bulkAddResponse.totalNotAdded != 0">
        <table id="table" style="width: 100%;" > 
          <tr>
            <th>Row no.</th>
            <th>Name</th>
            <th>Email</th>
            <th>Reason</th>
          </tr>
          <tr class="ml-0" v-for="(item, index) in bulkAddResponse.studentsNotAdded" :key="index">
            <td>
              {{ item.rowNumber }}
            </td>
            <td>
              {{ item.firstname }} {{ item.lastname }}
            </td>
            <td>
              {{ item.email }}
            </td>
            <td>
              {{ item.message }}
            </td>
          </tr>
        </table>

        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col" style="display: flex;">
            <vs-button class="mt-4" icon-pack="feather" icon="icon-copy" @click="selectElementContents">Copy to Clipboard</vs-button>
            <vs-button class="mt-4 ml-4" color="success" icon-pack="feather" icon="icon-download" @click="exportToExcel">Download .csv</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup id="preview-popup" title="Preview" :active.sync="previewPopupActive">
      <div class="vx-row mx-auto">
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full xs:w-full">
          <div class="w-full">
            <ul style="flex-wrap: wrap;">
              <div class="limit-width_fixed-scalable" style="text-align: left;">
                <li>
                  <span style="display: inline-flex">
                    <img id="profileimg" src="https://forty5degreesstorage.blob.core.windows.net/user/avatar_default.png" style="width: 25%; height: auto;">
                    <div>
                      <p style="font-size: 16pt;color:white;" class="ml-4 mt-3">Hi Student,</p>
                      <p style="font-size: 11pt;color:white;" class="ml-4">Welcome back!</p>
                      <p style="font-size: 11pt;font-weight: 500;" class="ml-4 text__school-tertiary-color underline__hover-only"><small><strong>Choose another Language & Grade</strong></small></p>
                    </div>
                  </span>
                </li>
                <li>
                  <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 410px">
                    <vx-input-group>
                      <template slot="prepend">
                        <div class="prepend-text glow-effect_bg-color__blend bg-color">
                          <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                        </div>
                      </template>

                      <vs-button
                        :disabled="true"
                        size="large"
                        class="button__fully-opaque button-text__left-align remove-shadow header_button-item text__school-font-color"
                        type="filled"
                        color="">
                        Select a Subject
                      </vs-button>
                    </vx-input-group>
                  </vx-card>
                </li>
              </div>
              <li class="mb-4">
                <vx-card class="glow-effect_dark card__no-padding bg-color" style="width: 540px">
                  <vx-input-group>
                    <template slot="prepend">
                      <vs-button :disabled="true" id="new-content" size="small" radius color="#4e5c9a" type="filled" icon-pack="feather" icon="icon-star" class="button__fully-opaque glow-effect_light"></vs-button>
                      <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                        <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0">
                      Home Language
                    </vs-button>
                    <span id="unstar-subject_btn-container"><feather-icon id="unstar-subject_btn" icon="StarIcon" svg-classes="stroke-current" /></span>
                  </vx-input-group>
                </vx-card>
              </li>
              <li class="mb-4">
                <vx-card class="glow-effect_dark card__no-padding bg-color" style="width: 540px">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                        <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0">
                      First Additional Language
                    </vs-button>
                    <span id="unstar-subject_btn-container"><feather-icon id="unstar-subject_btn" icon="StarIcon" svg-classes="stroke-current" /></span>
                  </vx-input-group>
                </vx-card>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  data() {
    return {
      headerTitle: ["RowNumber","Firstname","Lastname","Email","Message"],
      headerVal: ["rowNumber","firstname","lastname","email","message"],
      bulkNotAddedPopupActive: false,
      studentsNotAdded: "",
      bulkCsvFileUrl: "",
      canCancel: true,
      isLoading: false,
      isBulkLoading: false,
      isBulkAddHidden: true,
      themeColors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      defaultTheme: 'light',
      defaultThemeColor: '#7367F0',
      defaultNavbarType: 'floating',
      defaultNavbarColor:'#7367F0',
      navbarType: "",
      navbarColor: "",
      themeColor: "",
      customPrimaryColor: "#3DC9B3",
      customNavbarColor: "#3DC9B3",
      loadingColor: "#fff",
      selected: [],
      isInfoHidden: true,
      isSiteListHidden: false,
      isAdminInfoHidden: false,
      sites: [],
      formData: {
        id: 0,
        companyName: "",
        siteTypeId: "",
        InheritSiteId: "",
        vatNumber: "",
        registration: "",
        employeeNumber: null,
        address: "",
        firstName: "",
        lastName: "",
        work: "",
        mobile: "",
        email: "",
        logoUrl: "",
        homePageImageUrl: "",
        password: "",
        passwordConfirm: "",
        themeColor: "",
        navbarColor: "",
        navbarType: "",
        theme: "",
        webIntegrationUsername: "",
        webIntegrationPassword: "",
        schoolPrimaryColor: "",
        schoolSecondaryColor: "",
        schoolTertiaryColor: "",
        schoolFontColor: "",
        isMentoringAvailable: false,
        virtualClassroom: false,
        emailNotificationsEnabled: false,
        oneTaskAttempt:false,
      },
      typeList: [],
      inheritList: [],
      defaultPassword: "12345678",
      currentUser: {},
      canAddSites: false,
      bulkAddResponse: {},
      typeDropdown: 0,
      inheritDropdown: 0,
      schoolCustomPrimaryColor: "#E3E3E3",
      schoolCustomSecondaryColor: "#E3E3E3",
      schoolCustomTertiaryColor: "#E3E3E3",
      schoolCustomFontColor: "#E3E3E3",
      previewPopupActive: false,
    };
  },
  computed: {
    theme: {
      get() {
        return this.$store.state.theme;
      },
      set(val) {
        if (!val)
          val = this.defaultTheme;
        this.$store.dispatch("updateTheme", val);
        this.$vs.theme({ primary: this.themeColor });
        this.$emit("updateNavbarColor", this.navbarColorLocal);
      }
    },
    navbarTypeLocal: {
      get() {
        return this.navbarType;
      },
      set(val) {
        if (!val)
          val = this.defaultNavbarType;
        this.navbarType = val;
        if (val != "static") {
          this.$emit("updateNavbar", val);
          this.$emit("updateNavbarColor", this.navbarColorLocal);
        } else {
          this.$emit("updateNavbar", val);
          this.$emit("updateNavbarColor", "#fff");
        }
        this.$emit("updateNavbar", val);
      }
    },
    navbarColorLocal: {
      get() {
        return this.navbarColor;
      },
      set(val) {
        if (!val)
          val = this.defaultNavbarColor;
        this.navbarColor = val;
        if (this.navbarType != "static") this.$emit("updateNavbarColor", val);
        else {
          this.$emit("updateNavbarColor", "#fff");
        }
      }
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    primaryColor: {
      get() {
        return this.$store.state.themePrimaryColor;
      },
      set(val) {
        if (!val)
          val = this.defaultThemeColor;
        this.themeColor = val;
        this.$store.commit("UPDATE_PRIMARY_COLOR", val);
      }
    },
  },
  watch: {
    themeColor: function(val) {
      this.$vs.theme({ primary: val });
    },
    previewPopupActive: function(val) {
      if (val) {
        this.$vs.theme({ primary: this.formData.schoolPrimaryColor });
        this.$vs.theme({ secondary: this.formData.schoolSecondaryColor });
        this.$vs.theme({ tertiary: this.formData.schoolTertiaryColor });
        this.$vs.theme({ fontcolor: this.formData.schoolFontColor });
      }
      else {
        this.$vs.theme({ primary: this.themeColor });
      }
    }
  },
  methods: {
    setSchoolPrimaryColor (color) {
      this.formData.schoolPrimaryColor = color;

      this.primaryColor = color;
      this.themeColor = color;
      this.$vs.theme({ primary: color });
      this.navbarColorLocal = color;
    },
    setSchoolSecondaryColor (color) {
      this.formData.schoolSecondaryColor = color;
    },
    setSchoolTertiaryColor (color) {
      this.formData.schoolTertiaryColor = color;
    },
    setSchoolFontColor (color) {
      this.formData.schoolFontColor = color;
    },
    openPreviewPopup() {
      this.previewPopupActive = true;
    },
    getTypes() {
      var self = this;

      var onSuccess = response => {
        self.typeList = response.data.map((item) => {return {label: item.text, value: item.value} });
      };
      
      self.$ajaxGet(self, "site/GetSiteTypes", onSuccess);
    },
    getInheritSites() {
      var self = this;

      var onSuccess = response => {
        self.inheritList = response.data.map((item) => {return {label: item.text, value: item.value} });
      };
      
      self.$ajaxGet(self, "site/GetSchools", onSuccess);
    },
    selectElementContents(el) {
      var el = document.getElementById('table');
      var body = document.body, range, sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
        document.execCommand("copy");
        this.$vs.notify({
          color: "success",
          text: "Copied!",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-clipboard"
        });
      } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
        range.execCommand("Copy");
        this.$vs.notify({
          color: "success",
          text: "Copied!",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-clipboard"
        });
      }
      sel.removeAllRanges();
    },
    exportToExcel() {
      var self = this;
      import('@/vendor/Export2Excel').then(excel => {
        const list = self.bulkAddResponse.studentsNotAdded;
        const data = self.formatJson(self.headerVal, list)
        excel.export_json_to_excel({
          header: self.headerTitle,
          data,
          filename: `${self.bulkAddResponse.totalNotAdded}_students_not_added_for_site_${self.formData.companyName}`,
          autoWidth: false,
          bookType: "csv"
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    initValues() {
      this.formData.id = 0;
      this.formData.companyName = "";
      this.formData.siteTypeId = "";
      this.formData.inheritSiteId = "";
      this.formData.vatNumber = "";
      this.formData.registration = "";
      this.formData.employeeNumber = null;
      this.formData.address = "";
      this.formData.firstName = "";
      this.formData.lastName = "";
      this.formData.work = "";
      this.formData.mobile = "";
      this.formData.email = "";
      this.formData.password = "";
      this.formData.passwordConfirm = "";
      this.formData.logoUrl = "";
      this.formData.virtualClassroom = false;
      this.formData.emailNotificationsEnabled = false;
      this.formData.themeColor = this.defaultThemeColor;
      this.formData.navbarColor = this.defaultNavbarColor;
      this.formData.navbarType = this.defaultNavbarType;
      this.formData.theme = this.defaultTheme ;
      this.formData.webIntegrationUsername = "";
      this.formData.webIntegrationPassword = "";
      this.formData.schoolPrimaryColor = "";
      this.formData.schoolSecondaryColor = "";
      this.formData.schoolTertiaryColor = "";
      this.formData.schoolFontColor = "";
      this.formData.isMentoringAvailable = false;
      this.formData.learningStyleB = false;
      this.formData.oneTaskAttempt = false;
      this.isLoading = false;
      this.isBulkLoading = false;
      this.bulkCsvFileUrl = "";
      this.canCancel = true;

      this.typeDropdown = 0;

      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
        this.customPrimaryColor = JSON.parse(localStorage.getItem("userSiteInfo"))[0].themeColor
      else
        this.customPrimaryColor = JSON.parse(localStorage.getItem("userSiteInfo")).themeColor
       
      this.errors.clear();
    },
    updatePrimaryColor(color) {
      this.primaryColor = color;
      this.themeColor = color;
      this.$vs.theme({ primary: color });
    },
    getCurrentUser(success) {
      var self = this;
      var onSuccess = function (response) {
        self.currentUser = response.data;
        success();
      };
      self.$ajaxGet(self, "user/GetCurrentUserInfo", onSuccess);
    },
    cancelAdd() {
      this.initValues();
      this.resetTheme();
      this.isInfoHidden = true;
      this.isSiteListHidden = false;
      this.isAdminInfoHidden = true;
    },
    addNewSite() {
      this.errors.clear();
      this.initValues();
      this.isSiteListHidden = true;
      this.isAdminInfoHidden = false;
      this.isInfoHidden = false;
      this.addUploaderClickEvents();
    },
    saveData() {
      this.showLoadingOnTable();
      this.loadSiteData();
      this.$vs.loading.close(this.$refs.saveEditButton.$el);
    },
    loadSiteData() {
      const self = this;

      var onSuccess = function(response) {
        self.sites = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.sitesTable.$el);
      };

      self.$ajaxGet(self, "site", onSuccess, onFinally);
    },
    resetTheme() {
      this.$emit("updateNavbar", "");
      this.$emit("updateNavbarColor", "");
      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array){
        this.$vs.theme({ primary: JSON.parse(localStorage.getItem("userSiteInfo"))[0].themeColor });
        this.$store.dispatch("updateTheme", JSON.parse(localStorage.getItem("userSiteInfo"))[0].theme);
      }
      else{ 
        this.$vs.theme({ primary: JSON.parse(localStorage.getItem("userSiteInfo")).themeColor });
        this.$store.dispatch("updateTheme", JSON.parse(localStorage.getItem("userSiteInfo")).theme);
      }
    },
    handleSelectedSite(sites) {
      this.resetTheme();
      this.addUploaderClickEvents();
      this.isSiteListHidden = true;
      this.isAdminInfoHidden = true;
      this.isInfoHidden = false;
      this.changePassword = false;
      this.formData.id = sites.id;
      this.formData.companyName = sites.companyName;
      this.formData.vatNumber = sites.vatNumber;
      this.formData.registration = sites.registration;
      this.formData.employeeNumber = sites.employeeNumber;
      this.formData.address = sites.address;
      this.formData.firstName = sites.firstName;
      this.formData.lastName = sites.lastName;
      this.formData.work = sites.work;
      this.formData.mobile = sites.mobile;
      this.formData.email = sites.email;
      this.formData.logoUrl = sites.logoUrl;
      this.formData.homePageImageUrl = sites.homePageImageUrl;
      this.formData.password = this.defaultPassword;
      this.formData.passwordConfirm = this.defaultPassword;
      this.formData.schoolPrimaryColor = sites.schoolPrimaryColor;
      this.schoolCustomPrimaryColor = sites.schoolPrimaryColor || sites.themeColor;
      this.formData.schoolSecondaryColor = sites.schoolSecondaryColor;
      this.schoolCustomSecondaryColor = sites.schoolSecondaryColor || sites.themeColor;
      this.formData.schoolTertiaryColor = sites.schoolTertiaryColor;
      this.schoolCustomTertiaryColor = sites.schoolTertiaryColor || sites.themeColor;
      this.formData.schoolFontColor = sites.schoolFontColor;
      this.schoolCustomFontColor = sites.schoolFontColor || '#ffffff';
      this.formData.isMentoringAvailable = sites.isMentoringAvailable;
      this.formData.learningStyleB = sites.learningStyleB;
      this.formData.virtualClassroom = sites.virtualClassroom;
      this.formData.emailNotificationsEnabled = sites.emailNotificationsEnabled;
      this.formData.oneTaskAttempt = sites.oneTaskAttempt;
      
      this.theme = sites.theme;
      this.navbarTypeLocal = sites.navbarType;
      this.navbarColorLocal = sites.navbarColor;
      this.themeColor = sites.themeColor;
      this.$vs.theme({ primary: sites.themeColor });
      if(this.customPrimaryColor)
        this.customPrimaryColor = sites.themeColor;
      if(this.customNavbarColor)
        this.customNavbarColor = sites.navbarColor;
      
      this.formData.webIntegrationUsername = sites.webIntegrationUsername;
      this.formData.webIntegrationPassword = sites.webIntegrationPassword;

      this.typeDropdown = this.typeList.filter(function (item) { return item.value == sites.siteTypeId; })[0];
      this.inheritDropdown = this.inheritList.filter(function(item){return item.value == sites.inheritSiteId;})[0];
    },
    saveEditSite() {
      var self = this;
      if (!self.formData.logoUrl) {
        self.$vs.notify({
          title: "Attention",
          color: "danger",
          text: "Please upload a site logo.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-upload"
        });
        return;
      }

      self.formData.siteTypeId = self.typeDropdown ? parseInt(self.typeDropdown.value) : null;
      self.formData.inheritSiteId = self.inheritDropdown ? parseInt(self.inheritDropdown.value) : null;

      if(!self.formData.siteTypeId) {
        self.$vs.notify({
          title: "Attention",
          color: "danger",
          text: "Please select a site type from the dropdown.",
          position: "top-right",
          iconPack: "feather",
          icon: "alert-circle",
          time: 4000
        });
        return;
      }

      var siteObject = {};
      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
        siteObject = JSON.parse(localStorage.getItem("userSiteInfo"))[0];
      else
        siteObject = JSON.parse(localStorage.getItem("userSiteInfo"));

      siteObject.siteTypeId = self.formData.siteTypeId;
      localStorage.setItem("userSiteInfo", JSON.stringify(siteObject))
      
      this.formData.navbarType = this.navbarType;
      this.formData.navbarColor = this.navbarColor;
      this.formData.theme = this.theme;
      this.formData.themeColor = this.themeColor;


      if (self.formData.siteTypeId == 1) {
        this.formData.theme = "light";
        this.formData.navbarType = "floating";
        this.formData.themeColor = this.formData.schoolPrimaryColor;
        this.formData.navbarColor = this.formData.schoolPrimaryColor;
      }
      
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnSaveButton();

          var onSuccess = response => {
            self.isInfoHidden = true;
            self.scrollToNavbar();
            self.isSiteListHidden = false;
            self.isAdminInfoHidden = true;
            self.saveData();
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Site Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.saveEditButton.$el);
          };
          self.$ajaxPost(self, "site", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text:  self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    successUpload(data) {
      this.isLoading = false;
      this.formData.logoUrl = data[0].url;
    },
    successUploadHomePageImage(data) {
      this.isLoading = false;
      this.formData.homePageImageUrl = data[0].url;
    },
    cancelBulkAdd() {
      this.bulkCsvFileUrl = "";
      this.isBulkAddHidden = true;
      this.isBulkLoading = false;
      this.canCancel = true;
      this.$vs.loading.close(this.$refs.bulkUpload.$el);
    },
    bulkStudentAdd() {
      this.isBulkAddHidden = false;
      this.scrollToFooter();
    },
    csvSuccessUpload(data) {
      this.isBulkLoading = false;
      this.bulkCsvFileUrl = data[0].url;
    },
    confirmBulkStudentAdd() {
      var self = this;
      self.canCancel = false;
      self.showLoadingOnElement('confirmBulkButton', 0.35, 'material');

      var onSuccess = response => {
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: response.data,
          time: 7000,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.confirmBulkButton.$el);
        self.cancelBulkAdd();
      };
      
      self.$ajaxGet(self, "Site/BulkStudentAdd?fileUrl=" + self.bulkCsvFileUrl + "&siteId=" + self.formData.id, onSuccess, onFinally);
    },
    downloadTemplate(){
      var self = this;
      window.open("https://lateralscaffolding.blob.core.windows.net/studentbulk/CompanyTemplate.csv");
    },
    showUpload() {
      this.formData.logoUrl = null;
    },
    showUploadHomePageImage() {
      this.formData.homePageImageUrl = null;
    },
    addUploaderClickEvents() {
      var self = this;

      self.$refs.fileUpload.$el.addEventListener("click", function(){
        if(!self.isLoading) {
          self.isLoading = true;
          self.showLoadingOnElement("fileUpload", 0.45, "material");
        }else{
          self.isLoading = false;
          self.$vs.loading.close(self.$refs.fileUpload.$el);
        }
      });

      self.$refs.homePageImageUpload.$el.addEventListener("click", function () {
        if (!self.isLoading) {
          self.isLoading = true;
          self.showLoadingOnElement("homePageImageUpload", 0.45, "material");
        } else {
          self.isLoading = false;
          self.$vs.loading.close(self.$refs.homePageImageUpload.$el);
        }
      });

      self.$refs.bulkUpload.$el.addEventListener("click", function(){
        if(!self.isBulkLoading) {
          self.isBulkLoading = true;
          self.showLoadingOnElement("bulkUpload", 0.45, "material");
        }else{
          self.isBulkLoading = false;
          self.$vs.loading.close(self.$refs.bulkUpload.$el);
        }
      });

    },
    showLoadingOnSaveButton() {
      var self = this;
      self.$vs.loading({
        background: self.loadingColor,
        type: "material",
        container: self.$refs.saveEditButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnTable() {
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$refs.sitesTable.$el,
        scale: 1
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
    scrollToFooter() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -480,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("footerGlobal"),
        100,
        scrollOptions
      );
    }
  },
  mounted() {
    var self = this;
    self.showLoadingOnTable();
    self.getTypes();
    self.getInheritSites();
    self.getCurrentUser( function() {
      self.canAddSites = self.currentUser.isSuperAdmin ? true : false
      self.loadSiteData();
      document.getElementsByClassName("input-search")[0].innerText = "";
      self.$refs.sitesTable.searchx = "";
    });
  }
};
</script>
<style lang="scss">
  #bulkNotAddedPopup div.vs-popup {
    width: 1000px;
  }

  div#bulkNotAddedPopup.vs-component.con-vs-popup.vs-popup-primary {
    div.vs-popup {
      header.vs-popup--header {
        i.vs-icon.notranslate.icon-scale.vs-popup--close.vs-popup--close--icon.material-icons.null {
          background: rgb(253, 0, 0) !important;
          color: rgb(255, 255, 255);
        }
      }
    }
  }

  $content-dark-bg: #262c49;
  $theme-dark-text-color: #c2c6dc;
  $dark-card-color: #10163a;
  #preview-popup.con-vs-popup{
    .vs-popup{
      background: $content-dark-bg !important;
      color: $theme-dark-text-color !important;
      .vs-popup--header{
        background: $dark-card-color !important;
        h3 {
          color: $theme-dark-text-color !important;
        }
        .vs-popup--close{
          background: $content-dark-bg !important;
          color: $theme-dark-text-color !important;
        }
      }
    }
  }
</style>
